import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";

// Components
import { CentralModal } from "../components/UI";

// Page specific components
import {
  BusinessProfileDetails,
  EditBusinesProfile
} from "../components/PageSpecificComponents/pagesComponents/businessProfileComponents";
import SubscriptionPanel from "../components/PageSpecificComponents/pagesComponents/billing/SubscriptionPanel";
import PaymentMethodsPanel from "../components/PageSpecificComponents/pagesComponents/billing/PaymentMethodsPanel";

// Icons
import { I } from "../components/PageSpecificComponents/pagesComponents/billing/icons";

// Constants
import * as bussinessConsts from "../constants/business-profile/business-profile.constants";

// Calls
import { fetchPaymentMethodsRequest } from "../api/calls/subscription.call";

// Actions
import {
  openModal,
  closeModal,
  fetchBusinessData
} from "../redux/actions/business.actions";

// Styles
import { BusinessProfileStyles } from "../pagesStyles/businessProfile.styles";

const BusinessProfile = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { business, location, activeSubscription, modalType } = useSelector(
    state => state.businessProfile
  );
  const [paymentMethods, setPaymentMethods] = useState([]);

  // Onboarding step 1 links here as /business-profile?setup=proof so the proof
  // dropzone can pulse instead of the user having to hunt for it.
  const ping = new URLSearchParams(search).get("setup") === "proof";

  const openEditBusinessProfileModal = useCallback(
    () => dispatch(openModal(bussinessConsts.EDIT_BUSINESS_PROFILE_MODAL)),
    [dispatch]
  );

  const closeModalHandler = useCallback(
    () => dispatch(closeModal()),
    [dispatch]
  );

  const refreshPaymentMethods = useCallback(async () => {
    const response = await fetchPaymentMethodsRequest();
    if (!response.hasError) {
      setPaymentMethods(response.paymentMethods);
    }
  }, []);

  useEffect(() => {
    dispatch(fetchBusinessData());
    refreshPaymentMethods();
  }, [dispatch, refreshPaymentMethods]);

  useEffect(() => {
    if (ping) window.scrollTo(0, 0);
  }, [ping]);

  return (
    <BusinessProfileStyles>
      <div className="tf-billing">
        <div className="tf-pagehead tf-pagehead-row">
          <div>
            <div className="tf-eyebrow">Business</div>
            <h1 className="tf-title">Business Profile</h1>
            <div className="tf-subtitle">
              Your company details, verification, subscription and payment
              methods. Personal login and password settings are in Account
              Settings.
            </div>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-ghost"
              onClick={openEditBusinessProfileModal}
            >
              <I.Building width="15" height="15" /> Edit Business Profile
            </button>
          </div>
        </div>
      </div>
      <div className="tf-billing bp-stack">
        <BusinessProfileDetails
          business={business}
          location={location}
          ping={ping}
        />
        <SubscriptionPanel
          activeSubscription={activeSubscription}
          cards={paymentMethods}
          onRefreshCards={refreshPaymentMethods}
        />
        <PaymentMethodsPanel
          cards={paymentMethods}
          onRefresh={refreshPaymentMethods}
        />
      </div>
      {modalType === bussinessConsts.EDIT_BUSINESS_PROFILE_MODAL && (
        <CentralModal
          closeModal={closeModalHandler}
          className="editBusinesProfileCard"
        >
          <EditBusinesProfile closeModal={closeModalHandler} />
        </CentralModal>
      )}
    </BusinessProfileStyles>
  );
};

export default BusinessProfile;
